import { parseISO, subMonths } from 'date-fns'
import type { Locale } from '@/types'

export const filter = (locale: Locale, currentDate: string) => ({
  active: {
    equalTo: true,
  },
  published: {
    equalTo: true,
  },
  locales: {
    anyEqualTo: locale,
  },
  and: [
    {
      or: [
        {
          publishAt: { isNull: true },
        },
        {
          publishAt: { lessThanOrEqualTo: currentDate },
        },
      ],
    },
    {
      or: [
        {
          expireAt: { isNull: true },
        },
        {
          expireAt: { greaterThan: currentDate },
        },
      ],
    },
  ],
})

export const createUnreadCountVariables = (
  locale: Locale,
  currentDate: string,
) => ({
  filter: {
    ...filter(locale, currentDate),
    userAnnouncementsExist: false,
    or: [
      {
        publishAt: {
          isNull: true,
        },
      },
      {
        publishAt: {
          greaterThan: subMonths(parseISO(currentDate), 1),
        },
      },
    ],
  },
})
